export const BOT_FLOW_TEXT_MESSAGE = "TEXT";
export const BOT_FLOW_QUICK_REPLY = "QUICK_REPLY";
export const BOT_FLOW_TEMPLATE_MESSAGE = "TEMPLATE_MESSAGE";
export const BOT_FLOW_ORDER_DETAILS_MESSAGE = "ORDER_DETAILS_MESSAGE";
export const BOT_FLOW_ORDER_STATUS_MESSAGE = "ORDER_STATUS_MESSAGE";
export const BOT_FLOW_MESSAGE_LINK = "MESSAGE_LINK";
export const BOT_FLOW_REROUTE = "REROUTE";
